import jQuery from 'jquery'
import 'jquery-validation';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";
import {gsap} from "gsap";

const customAnmation = new CustomAnimation();

// Backend endpoints — AmbilightZufriedenheitsgarantieStack Function URLs.
const UPLOAD_URL = 'https://mm2qk4kjyv2etuuzb7rlv7vxka0vlkwj.lambda-url.eu-central-1.on.aws/'; // erzeuge_url
const SUBMIT_URL = 'https://cmeiqfzh3qp4j3qnq2g5vuuwde0hqpvs.lambda-url.eu-central-1.on.aws/'; // bon_hochladen

class Registerpage {
  constructor() {
  }

  init() {
    this.initParallax();
    this.initForm();
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);
    customAnmation.animateHeaderImage('.header');
    customAnmation.animateFromBottom('.form-group');
    customAnmation.animateButtonGroup('.button');
  }

  initForm = () => {
    this.resetForm();

    const isFrench = document.documentElement.lang === 'fr';

    // Purchase must be within the last 100 days (return window) and not in the future ->
    // constrain the date picker to [today-100, today].
    const _today = new Date();
    const _earliest = new Date(_today);
    _earliest.setDate(_earliest.getDate() - 100);     // at most 100 days ago
    jQuery('#purchasedate')
      .attr('max', _today.toISOString().slice(0, 10))
      .attr('min', _earliest.toISOString().slice(0, 10));

    document.getElementById('proofofpurchase').addEventListener('change', async function (event) {
      const fileInput = event.target;
      const label = document.querySelector('label[for="proofofpurchase"]');
      if (fileInput.files.length > 0) {
        fileInput.setAttribute('uploading', 'true');
        if (fileInput.files[0].size > 10 * 1024 * 1024) {
          label.textContent = isFrench
            ? 'Fichier trop volumineux (max. 10 Mo)'
            : 'Die Datei ist zu groß (max. 10 MB).';
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
          return;
        }
        label.textContent = isFrench ? 'Téléchargement en cours…' : 'Upload läuft …';
        try {
          /* eslint-disable-next-line no-inner-declarations */
          async function uploadToS3(presigned) {
            const form = new FormData();
            Object.entries(presigned.fields).forEach(([k, v]) => form.append(k, v));
            form.append("file", fileInput.files[0]); // <input type="file" id="fileInput">

            const res = await fetch(presigned.url, {
              method: "POST",
              contentType: null,
              body: form,
            });

            if (!res.ok) {
              const text = await res.text(); // S3-Fehlermeldung (XML) lesen
              throw new Error(`S3 upload failed: ${res.status} ${text}`);
            }
            // Erfolg = i.d.R. HTTP 204, ETag in Headern
            console.log("OK. Key:", presigned.fields.key);
            return presigned.fields.key;
          }
          jQuery.ajax({
            type: 'POST',
            url: UPLOAD_URL,
            contentType: "application/json; charset=utf-8",   // wir senden JSON
            dataType: "json",                                // wir erwarten JSON zurück
            data: JSON.stringify({
              filename: fileInput.files[0].name
            }),
          }).done(function (signedUrl) {
            uploadToS3(signedUrl).then((key) => {
              label.textContent = isFrench
                ? `${fileInput.files[0].name} a été téléchargé avec succès`
                : `${fileInput.files[0].name} wurde erfolgreich hochgeladen`;
              fileInput.removeAttribute('uploading');
              fileInput.setAttribute('key', key);

            }).catch(err => {
              console.log(err)
              label.textContent = (isFrench ? 'Le téléchargement a échoué : ' : 'Der Upload ist fehlgeschlagen: ') + err;
              fileInput.value = "";
              fileInput.removeAttribute('uploading');
            });


          }).catch(err => {
            console.log(err);
            label.textContent = (isFrench ? 'Le téléchargement a échoué : ' : 'Der Upload ist fehlgeschlagen: ') + err.responseText;
            fileInput.value = "";
            fileInput.removeAttribute('uploading');
          })


        } catch (err) {
          console.log(err)
          label.textContent = (isFrench ? 'Le téléchargement a échoué : ' : 'Der Upload ist fehlgeschlagen: ') + err;
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
        }

      } else {
        label.textContent = isFrench
          ? 'Télécharger le justificatif d’achat Ambilight TV'
          : 'Kaufbeleg für Ambilight TV hochladen';
      }
    });

    const that = this;
    const formMessages = jQuery('#form-messages');

    const messagesDe = {
      gender: 'Bitte geben Sie Ihr Geschlecht an.',
      firstname: 'Bitte geben Sie Ihren Vornamen ein.',
      lastname: 'Bitte geben Sie Ihren Nachnamen ein.',
      email: 'Bitte geben Sie Ihre gültige E-Mail-Adresse ein.',
      email_repeat: 'Bitte geben Sie Ihre E-Mail-Adresse erneut ein.',
      street: 'Bitte geben Sie Ihre Straße ein.',
      street_number: 'Bitte geben Sie Ihre Hausnummer ein.',
      postcode: 'Bitte geben Sie Ihre Postleitzahl ein.',
      city: 'Bitte geben Sie Ihren Wohnort ein.',
      country: 'Bitte geben Sie Ihr Wohnsitzland an.',

      proofofpurchase: 'Bitte wählen Sie Ihren Kaufbeleg aus.',
      modelnumber: 'Bitte geben Sie die Modellnummer/Typenbezeichnung ein.',
      serialnumber: {
        required: 'Bitte geben Sie Ihre Seriennummer ein.',
        serialnumber: 'Die Seriennummer muss mit FZ beginnen und insgesamt 14 Zeichen enthalten.'
      },
      purchasedate: {
        required: 'Bitte geben Sie das Kaufdatum ein.',
        max: 'Das Kaufdatum darf nicht in der Zukunft liegen.',
        min: 'Das Kaufdatum darf nicht länger als 100 Tage zurückliegen.'
      },

      retailer: 'Bitte geben Sie den Namen des Händlers ein.',
      retailer_country: 'Bitte geben Sie das Land des Händlers an.',
      retailer_street: 'Bitte geben Sie die Straße des Händlers ein.',
      retailer_street_number: 'Bitte geben Sie die Hausnummer des Händlers ein.',
      retailer_postcode: 'Bitte geben Sie die Postleitzahl des Händlers ein.',
      retailer_city: 'Bitte geben Sie den Ort des Händlers ein.',

      participation: 'Bitte akzeptieren Sie die Teilnahmebedingungen und Datenschutzbestimmungen.',
      legalage: 'Bitte bestätigen Sie, dass Sie volljährig sind.',
      analysis: 'Bitte akzeptieren Sie die Bedingungen.'
    };

    const messagesFr = {
      gender: 'Veuillez indiquer votre sexe.',
      firstname: 'Veuillez indiquer votre prénom.',
      lastname: 'Veuillez indiquer votre nom de famille.',
      email: 'Veuillez saisir une adresse e-mail valide.',
      email_repeat: 'Veuillez saisir à nouveau votre adresse e-mail.',
      street: 'Veuillez indiquer votre rue.',
      street_number: 'Veuillez indiquer votre numéro de rue.',
      postcode: 'Veuillez indiquer votre code postal.',
      city: 'Veuillez indiquer votre ville.',
      country: 'Veuillez indiquer votre pays de résidence.',

      proofofpurchase: 'Veuillez sélectionner votre preuve d’achat.',
      modelnumber: 'Veuillez indiquer le numéro de modèle ou la désignation du type.',
      serialnumber: {
        required: 'Veuillez saisir votre numéro de série.',
        serialnumber: 'Le numéro de série doit commencer par FZ et contenir 14 caractères au total.'
      },
      purchasedate: {
        required: 'Veuillez indiquer la date d’achat.',
        max: 'La date d’achat ne peut pas être dans le futur.',
        min: 'La date d’achat ne peut pas remonter à plus de 100 jours.'
      },

      retailer: 'Veuillez indiquer le nom du revendeur.',
      retailer_country: 'Veuillez indiquer le pays du revendeur.',
      retailer_street: 'Veuillez indiquer la rue du revendeur.',
      retailer_street_number: 'Veuillez indiquer le numéro de rue du revendeur.',
      retailer_postcode: 'Veuillez indiquer le code postal du revendeur.',
      retailer_city: 'Veuillez indiquer la ville du revendeur.',

      participation: 'Veuillez accepter les conditions de participation et la politique de confidentialité.',
      legalage: 'Veuillez confirmer que vous êtes majeur(e).',
      analysis: 'Veuillez accepter les conditions.'
    };

    jQuery.validator.addMethod("serialnumber", function(value, element) {
      return this.optional(element) || /^FZ[A-Za-z0-9]{12}$/.test(value);
    }, "Die Seriennummer muss mit FZ beginnen und insgesamt 14 Zeichen enthalten.");

    jQuery("#registration").validate({

      rules: {
        gender: 'required',
        firstname: 'required',
        lastname: 'required',
        email: {
          required: true,
          email: true
        },
        email_repeat: {
          required: true,
          email: true,
          equalTo: '#email'
        },
        street: 'required',
        street_number: 'required',
        postcode: 'required',
        city: 'required',
        country: {
          required: true
        },

        proofofpurchase: 'required',
        modelnumber: 'required',

        serialnumber: {
          required: true,
          serialnumber: true
        },

        purchasedate: 'required',
        retailer: 'required',
        retailer_country: {
          required: true
        },
        retailer_street: 'required',
        retailer_street_number: 'required',
        retailer_postcode: 'required',
        retailer_city: 'required',

        participation: 'required',
        legalage: 'required'
      },
      messages: isFrench ? messagesFr : messagesDe,
      submitHandler(form) {
        const formData = jQuery(form).serializeArray().reduce((obj, item) => {
          obj[item.name] = item.value;
          return obj;
        }, {});

        formData['language'] = isFrench ? 'fr' : 'de';
        formData['lang'] = document.documentElement.lang;

        if (jQuery('#proofofpurchase')[0].hasAttribute('uploading')) {
          formMessages.text(isFrench
            ? 'Veuillez patienter pendant le téléchargement de la preuve d’achat.'
            : 'Bitte warten Sie, bis der Kaufbeleg hochgeladen wurde.');
          return
        } else if (jQuery('#proofofpurchase')[0].hasAttribute('key')) {
          formData['proofofpurchase'] = jQuery('#proofofpurchase').attr('key');
        }

        that.submitForm(formData, formMessages);
      }
    });
  }

  submitForm(formData, formMessages) {
    const isFrench = document.documentElement.lang === 'fr';
    jQuery('.button_form_send').addClass('button_loading');
    jQuery.ajax({
      type: 'POST',
      url: SUBMIT_URL,
      data: JSON.stringify(formData),
      contentType: 'application/json',
      dataType: 'json',
      processData: false,
    })
      .done(function (response) {
        if(response){ // check whether response is received
          window.location.href = "thankyou.html";
        }
        formMessages.text(response.message);
      })
      .fail(function (data) {
        formMessages.text(
          data.message ||
          (isFrench
            ? 'Une erreur s’est produite et votre message n’a pas pu être envoyé.'
            : 'Es ist ein Fehler aufgetreten und Ihre Nachricht konnte nicht gesendet werden.')
        );
      });
  }

  resetForm_dummy() {
    jQuery('#gender').val('männlich');
    jQuery('#firstname').val('Sebastian');
    jQuery('#lastname').val('Annies');
    jQuery('#email').val('Sebastian.Annies@gmail.com');
    jQuery('#email_repeat').val('Sebastian.Annies@gmail.com');
    jQuery('#street').val('Bei der Apostelkriche');
    jQuery('#street_number').val('12');
    jQuery('#postcode').val('20257');
    jQuery('#city').val('Hamburg');
    jQuery('#country').val('deutschland');

    jQuery('#proofofpurchase').val('');
    jQuery('#modelnumber').val('TR2345678');
    jQuery('#serialnumber').val('21345678');
    jQuery('#purchasedate').val('2025-01-15');

    jQuery('#retailer').val('Mediamarkt');
    jQuery('#retailer_country').val('Deutschland');
    jQuery('#retailer_street').val('Hauptstrasse');
    jQuery('#retailer_street_number').val('19');
    jQuery('#retailer_postcode').val('22222');
    jQuery('#retailer_city').val('Hamburg');

    jQuery('#participation').prop('checked', true);
    jQuery('#legalage').prop('checked', true);
    jQuery('#analysis').prop('checked', true);
  }

  resetForm() {
    jQuery('#gender').val('');
    jQuery('#firstname').val('');
    jQuery('#lastname').val('');
    jQuery('#email').val('');
    jQuery('#email_repeat').val('');
    jQuery('#street').val('');
    jQuery('#street_number').val('');
    jQuery('#postcode').val('');
    jQuery('#city').val('');
    jQuery('#country').val('');

    jQuery('#proofofpurchase').val('');
    jQuery('#modelnumber').val('');
    jQuery('#serialnumber').val('');
    jQuery('#purchasedate').val('');

    jQuery('#retailer').val('');
    jQuery('#retailer_country').val('');
    jQuery('#retailer_street').val('');
    jQuery('#retailer_street_number').val('');
    jQuery('#retailer_postcode').val('');
    jQuery('#retailer_city').val('');

    jQuery('#participation').prop('checked', false);
    jQuery('#legalage').prop('checked', false);
    jQuery('#analysis').prop('checked', false);
  }
}

export default Registerpage;
